/**
 * Nexus Caregiver.PrimaryLanguage values and labels, in Nexus display order.
 *
 * Source: .nexus/export-link/schema/PicklistValue/PrimaryLanguage*.json
 */
export const CAREGIVER_PRIMARY_LANGUAGE_OPTIONS = [
  { value: 'ENGLISH', label: 'English' },
  { value: 'SPANISH', label: 'Spanish' },
  { value: 'ALBANIAN', label: 'Albanian' },
  { value: 'ARABIC', label: 'Arabic' },
  { value: 'BANGLA', label: 'Bangla' },
  { value: 'BENGALI', label: 'Bengali' },
  { value: 'BOSNIAN', label: 'Bosnian' },
  { value: 'BULGARIAN', label: 'Bulgarian' },
  { value: 'CHINESE', label: 'Chinese' },
  { value: 'CREOLE', label: 'Creole' },
  { value: 'FARSI', label: 'Farsi' },
  { value: 'FILIPINO', label: 'Filipino' },
  { value: 'FRENCH', label: 'French' },
  { value: 'FULA_FULANI', label: 'Fula/Fulani' },
  { value: 'GREEK', label: 'Greek' },
  { value: 'GERMAN', label: 'German' },
  { value: 'HEBREW', label: 'Hebrew' },
  { value: 'HINDI', label: 'Hindi' },
  { value: 'IGBO', label: 'Igbo' },
  { value: 'ITALIAN', label: 'Italian' },
  { value: 'NEPALI', label: 'Nepali' },
  { value: 'POLISH', label: 'Polish' },
  { value: 'PORTUGUESE', label: 'Portuguese' },
  { value: 'RUSSIAN', label: 'Russian' },
  { value: 'SIGN_LANGUAGE_AMERICAN', label: 'Sign Language - American' },
  { value: 'SINHALA', label: 'Sinhala' },
  { value: 'TAGALOG', label: 'Tagalog' },
  { value: 'TWI', label: 'Twi' },
  { value: 'URDU', label: 'Urdu' },
  { value: 'YORUBA', label: 'Yoruba' },
  { value: 'FULA', label: 'Fula' },
  { value: 'FULANI', label: 'Fulani' },
] as const;

/**
 * Nexus Caregiver.citizenStatus values and labels, in Nexus display order.
 *
 * Source: .nexus/export-link/schema/PicklistValue/CaregiverCitizenStatus*.json
 */
export const CAREGIVER_CITIZEN_STATUS_OPTIONS = [
  { value: 'A_CITIZEN_OF_THE_UNITED_STATES', label: 'A citizen of the United States' },
  { value: 'A_NONCITIZEN_NATIONAL_OF_THE_UNITED_STATES', label: 'A noncitizen national of the United States' },
  { value: 'A_LAWFUL_PERMANENT_RESIDENT', label: 'A lawful permanent resident' },
  { value: 'AN_ALIEN_AUTHORIZED_TO_WORK', label: 'An alien authorized to work' },
] as const;
